<template>

    <div class="input-color-swatches">
        <div class="swatches">
            <div v-for="s in presets"
                :key="s"
                :style="`background-color:${s};`"
                class="swatch"
                @click="onChange(s)">
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .input-color-swatches {
        .swatches {
            display: flex;
        }
        .swatch {
            border-radius: 3px;
            cursor: pointer;
            height: 24px;
            margin-right: 5px;
            transition: .3s opacity;
            width: 24px;
            &:hover {
                opacity: 0.5;
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            presets: [
                '#333333',
                '#0064ff',
                // Rainbow
                '#D0021B',
                '#ff8c00',
                '#417505',
                '#00CED1',
                '#9013FE',
                '#FF00FF',
                '#664c28',
            ],
        }
    },

    methods: {

        onChange(color) {
            this.$emit('input', color);
        },

    },

}

</script>
